import {useEffect} from 'react';
import * as localStorage from "../../tools/storage";
import {getCurrentQueryObject} from "../../tools/func";
import {useParams} from 'react-router-dom';

export default function AutoLogin() {
    const params = useParams()
    useEffect(() => {
        const {to} = getCurrentQueryObject();
        if (params.access_token) {
            localStorage.setItem('access_token', params.access_token);
            window.location = to || "/"
        }
    }, [params.access_token])
    return null;
}
